import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';

import { currentReturnTo } from './returnTo';

export const Auth0LoginButton: React.FC = () => {
    const { loginWithRedirect } = useAuth0();

    return (
        <p className='auth0-login-prompt' style={{ marginTop: 16, marginBottom: 0 }}>
            Curvball user?{' '}
            <a
                href='#'
                data-testid='auth0-login'
                onClick={e => {
                    e.preventDefault();
                    // Carried through Auth0 so a shared or bookmarked deep link survives the
                    // round trip - the native login preserves it only because it never leaves
                    // the page.
                    void loginWithRedirect({ appState: { returnTo: currentReturnTo() } });
                }}
            >
                Login here
            </a>
        </p>
    );
};
